
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "text": "text-1b632a66",
    "ellipsize": "ellipsize-1b632a66",
    "fit": "fit-1b632a66"
};
exports.styleSource = ".text-1b632a66{position:relative}.ellipsize-1b632a66{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.fit-1b632a66{position:absolute;top:0;left:0;width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
